<template>
  <v-row>
    <v-col cols="12">
      <v-card class="mx-auto">
        <v-data-table
          :headers="headers"
          :items="items"
          :expanded="expanded"
          item-key="id"
          show-expand
          :expanded.sync="expanded"
          :loading="loading"
          loading-text="Đang tải dữ liệu... Vui lòng chờ"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Phản hồi</v-toolbar-title>
              <v-divider
                class="mx-4"
                inset
                vertical
              />
              <v-spacer/>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Nhập từ khóa"
                single-line
                hide-details
                clearable
              />
            </v-toolbar>
          </template>
          <template v-slot:item.data-table-expand="{ expand, isExpanded }">
            <v-btn
              icon
              color="info"
              @click="expand(!isExpanded)"
            >
              <v-icon small>
                mdi-eye{{isExpanded ? '-off' : ''}}
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <v-simple-table style="background: transparent;">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Tiêu đề</th>
                      <th>Nội dung</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ item.title }}</td>
                      <td>{{ item.message }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
  import { mapState } from 'vuex';
  export default {
    data () {
      return {
        loading: false,
        dialog: false,
        errors_exist: false,
        errors: [],
        item: {

        },
        search: '',
        expanded: ['Donut'],
        singleExpand: false,
        headers: [
          { text: 'Tên liên hệ', value: 'name' },
          { text: 'Email', value: 'email' },
          { text: 'Số điện thoại', value: 'phone' },
          { text: 'Thời gian', value: 'created_at' },
          { 
            align: 'center',
            text: '#',
            value: 'data-table-expand',
            sortable: false
          },
        ],
        items: [],
      }
    },
    computed: {
      ...mapState([
        'authMod'
      ]),
    },
    mounted() {
      this.getMessages();
    },
    methods: {
      getMessages(){
        this.loading=true;
        let user = this.authMod.user.user;
        let businessId = user.info.coso_id;
        axios.get(`api/v1/businesses-get-message/${businessId}`)
          .then(response => {
            this.items = response.data;
            this.loading=false;
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    }
  }
</script>